import { useSelector } from 'src/hooks/useSelector';
import { getLanguageLevel } from 'src/utils/resume/getLanguageLevel';

export const useConvertLanguageLevel = (record: string): string | null => {
    const languages = useSelector((state) => state.languages);
    return getLanguageLevel({ languages: languages.language, record });
};
